/**
 * "1 source" / "2 sources". One helper because the footprint counts a great many things in
 * a great many places, and a per-component copy is how two surfaces end up disagreeing
 * about the singular of the same noun.
 *
 * Regular nouns only, by design: it takes the plural outright when the noun is irregular,
 * so a caller is never silently handed "3 persons".
 */
export const plural = (count: number, singular: string, pluralForm = `${singular}s`) =>
    `${count} ${count === 1 ? singular : pluralForm}`;
